import React, { useState, useEffect } from "react";
import Navbar from "../Navbar/Navabar";
import Footer from "../../components/Footer/Footer";
import {
  Search,
  Filter,
  X,
  ZoomIn,
  ChevronLeft,
  ChevronRight,
} from "lucide-react";
import "./Gallery.css";

const galleryImages = [
  {
    id: 1,
    src: "/images/gallery1.avif",
    category: "poultry",
    title: "Free Range Chickens",
    description: "Healthy chickens roaming in natural pasture",
  },
  {
    id: 2,
    src: "/images/fish1.jpg",
    category: "aqua",
    title: "Fresh Water Fish",
    description: "Sustainable aquaculture farming",
  },
  {
    id: 3,
    src: "/images/cow.jpg",
    category: "animals",
    title: "Dairy Cattle",
    description: "Premium cattle in green pastures",
  },
  {
    id: 4,
    src: "/images/gallery2.avif",
    category: "poultry",
    title: "Organic Egg Production",
    description: "Farm-fresh organic eggs from happy hens",
  },
  {
    id: 5,
    src: "/images/fish2.jpg",
    category: "aqua",
    title: "Salmon Farming",
    description: "Modern salmon aquaculture facility",
  },
  {
    id: 6,
    src: "/images/cow2.jpg",
    category: "animals",
    title: "Sheep Grazing",
    description: "Sustainable sheep farming practices",
  },
  {
    id: 7,
    src: "/images/gallery3.avif",
    category: "poultry",
    title: "Turkey Farm",
    description: "Heritage breed turkeys in natural habitat",
  },
  {
    id: 8,
    src: "/images/fish3.jpg",
    category: "aqua",
    title: "Shrimp Cultivation",
    description: "Sustainable shrimp farming operations",
  },
  {
    id: 9,
    src: "/images/cow1.avif",
    category: "animals",
    title: "Pig Farming",
    description: "Modern pig farming with high welfare standards",
  },
  {
    id: 10,
    src: "/images/gallery4.avif",
    category: "poultry",
    title: "Duck Farming",
    description: "Free-range ducks in pond environment",
  },
  {
    id: 11,
    src: "/images/fish4.jpg",
    category: "aqua",
    title: "Tilapia Farming",
    description: "Indoor tilapia aquaculture system",
  },
  {
    id: 12,
    src: "/images/cow3.avif",
    category: "animals",
    title: "Goat Farming",
    description: "Heritage goat breeds for sustainable farming",
  },
 {
  id: 13,
  src: "/images/office1.jpeg",
  category: "office",
  title: "Corporate Headquarters",
  description: "Our modern administrative hub designed for productivity and collaboration",
},
{
  id: 14,
  src: "/images/office2.jpeg",
  category: "office",
  title: "Executive Conference Room",
  description: "A professional space for leadership meetings and strategic discussions",
},
{
  id: 15,
  src: "/images/office3.jpeg",
  category: "office",
  title: "Research & Innovation Lab",
  description: "Focused environment for experimentation, analysis, and innovation",
},
{
  id: 16,
  src: "/images/office4.jpeg",
  category: "office",
  title: "Client Support Operations",
  description: "Dedicated workspace delivering reliable customer assistance",
},
{
  id: 17,
  src: "/images/office5.jpeg",
  category: "office",
  title: "Open Work Environment",
  description: "Collaborative open-office layout that encourages teamwork and creativity",
},
{
  id: 18,
  src: "/images/office6.jpeg",
  category: "office",
  title: "Team Collaboration Zone",
  description: "An energetic space where teams brainstorm and build solutions together",
},
{
  id: 19,
  src: "/images/office7.jpeg",
  category: "office",
  title: "Training & Development Area",
  description: "Equipped space for employee training, workshops, and skill development",
},
{
  id: 20,
  src: "/images/office8.jpeg",
  category: "office",
  title: "Operations Control Room",
  description: "Central monitoring area ensuring smooth business operations",
},


];

const categories = [
  { id: "all", name: "All", color: "bg-gray-600", textColor: "text-white" },
  { id: "poultry", name: "Poultry", color: "bg-orange-600", textColor: "text-white" },
  { id: "aqua", name: "Aquaculture", color: "bg-blue-600", textColor: "text-white" },
  { id: "animals", name: "Livestock", color: "bg-green-600", textColor: "text-white" },
  { id: "office", name: "Office", color: "bg-purple-600", textColor: "text-white" },
];

const GalleryPage = () => {
  const [selectedCategory, setSelectedCategory] = useState("all");
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredImages, setFilteredImages] = useState(galleryImages);
  const [selectedImage, setSelectedImage] = useState(null);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Simulate loading
    setTimeout(() => setIsLoading(false), 1000);
  }, []);

  useEffect(() => {
    let filtered = galleryImages;

    if (selectedCategory !== "all") {
      filtered = filtered.filter((img) => img.category === selectedCategory);
    }

    if (searchTerm) {
      filtered = filtered.filter(
        (img) =>
          img.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
          img.description.toLowerCase().includes(searchTerm.toLowerCase())
      );
    }

    setFilteredImages(filtered);
  }, [selectedCategory, searchTerm]);

  const openLightbox = (image, index) => {
    setSelectedImage(image);
    setCurrentImageIndex(index);
  };

  const closeLightbox = () => {
    setSelectedImage(null);
  };

  const navigateImage = (direction) => {
    const newIndex =
      direction === "next"
        ? (currentImageIndex + 1) % filteredImages.length
        : (currentImageIndex - 1 + filteredImages.length) %
          filteredImages.length;

    setCurrentImageIndex(newIndex);
    setSelectedImage(filteredImages[newIndex]);
  };

  if (isLoading) {
    return (
      <div className="loading-container">
        <div className="loading-spinner"></div>
        <p className="loading-text">Loading Gallery...</p>
      </div>
    );
  }

  return (
    <>
      <div>
        <Navbar />
      </div>
      <div className="gallery-page">
        {/* Hero Banner */}
        <section className="hero-banner">
          <div className="hero-overlay"></div>
          <div className="hero-content">
            <h1 className="hero-title">
              <span className="hero-title-main">Our Gallery</span>
              <span className="hero-title-sub">
                Poultry, Livestock, Aquaculture & Office Excellence
              </span>
            </h1>
            <p className="hero-description">
              Discover our sustainable farming practices and modern facilities through stunning photography
            </p>
          </div>
          <div className="hero-scroll-indicator">
            <div className="scroll-arrow"></div>
          </div>
        </section>

        {/* Controls Section */}
        <section className="controls-section">
          <div className="container">
            <div className="controls-wrapper">
              {/* Search Bar */}
              <div className="search-container">
                <Search className="search-icon" size={20} />
                <input
                  type="text"
                  placeholder="Search gallery..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  className="search-input"
                />
              </div>

              {/* Category Filter */}
              <div className="filter-container">
                <Filter size={20} className="filter-icon" />
                <div className="category-buttons">
                  {categories.map((category) => (
                    <button
                      key={category.id}
                      onClick={() => setSelectedCategory(category.id)}
                      className={`category-btn ${category.textColor} ${
                        selectedCategory === category.id ? "active" : ""
                      } ${category.color}`}
                    >
                      {category.name}
                    </button>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Gallery Grid */}
        <section className="gallery-section">
          <div className="container">
            {filteredImages.length === 0 ? (
              <div className="no-results">
                <p>No images found matching your criteria.</p>
              </div>
            ) : (
              <div className="gallery-grid">
                {filteredImages.map((image, index) => {
                  const categoryData = categories.find((cat) => cat.id === image.category);
                  return (
                    <div
                      key={image.id}
                      className="gallery-item"
                      onClick={() => openLightbox(image, index)}
                    >
                      <div className="image-container">
                        <img
                          src={image.src}
                          alt={image.title}
                          className="gallery-image"
                          onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = "/images/placeholder.jpg";
                          }}
                        />
                        <div className="image-overlay">
                          <div className="overlay-content">
                            <ZoomIn className="zoom-icon" size={24} />
                            <h3 className="image-title">{image.title}</h3>
                            <p className="image-description">{image.description}</p>
                          </div>
                        </div>
                        <div
                          className={`category-badge ${categoryData?.color} ${categoryData?.textColor || 'text-white'}`}
                        >
                          {categoryData?.name}
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        </section>

        {/* Lightbox Modal */}
        {selectedImage && (
          <div className="lightbox-overlay" onClick={closeLightbox}>
            <div
              className="lightbox-container"
              onClick={(e) => e.stopPropagation()}
            >
              <button className="lightbox-close" onClick={closeLightbox}>
                <X size={24} />
              </button>

              <button
                className="lightbox-nav lightbox-prev"
                onClick={() => navigateImage("prev")}
              >
                <ChevronLeft size={24} />
              </button>

              <button
                className="lightbox-nav lightbox-next"
                onClick={() => navigateImage("next")}
              >
                <ChevronRight size={24} />
              </button>

              <div className="lightbox-content">
                <img
                  src={selectedImage.src}
                  alt={selectedImage.title}
                  className="lightbox-image"
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = "/images/placeholder.jpg";
                  }}
                />
                <div className="lightbox-info">
                  <h2 className="lightbox-title">{selectedImage.title}</h2>
                  <p className="lightbox-description">
                    {selectedImage.description}
                  </p>
                  <span
                    className={`lightbox-category ${
                      categories.find((cat) => cat.id === selectedImage.category)
                        ?.color
                    } text-white`}
                  >
                    {
                      categories.find((cat) => cat.id === selectedImage.category)
                        ?.name
                    }
                  </span>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
      <div>
        <Footer />
      </div>
    </>
  );
};

export default GalleryPage;